
const pathName = window.location.pathname;
// if(!pathName.includes('/products/')) {
//   return;
// }


const transformLetterToShort = (letter) => {
  if (letter.toLowerCase() == "white") {
    return "WL";
  }
  if (letter.toLowerCase() == "black") {
    return "BL";
  }
  if (letter.toLowerCase() == "gold") {
    return "GL";
  }
  return letter;
}

const customizerExternalLink = () => {

  const customizerExternalLinks = document.querySelectorAll('.product-bottom-bar .customizer-external-link');
  customizerExternalLinks.forEach((customizerExternalLink)=>{
    if (customizerExternalLink) {
    const form = document.querySelector('[is="product-form"]');
    const formData = new FormData(form);

    customizerExternalLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = document.querySelector('[is="product-form"]');
        const formData = new FormData(form);
        let url = customizerExternalLink.getAttribute('data-href');
        const qty =
          document?.querySelector('.buy-buttons [is="quantity-input"]')?.value ||
          document?.querySelector('[name="quantity"]')?.value || 1;

        const selected_option = formData.get("option3") || formData.get("option2") || formData.get("option1");
    
        const selector = document.querySelector(`variant-picker [value="${selected_option}"]`);
        const variantPicker = document.querySelector("variant-picker");
        if ((!selector?.checked && selector && selector.type === 'radio') && selected_option) {
          const errorMessage = document.createElement("div");
          errorMessage.className = "error-message";
          errorMessage.innerHTML = "Please select a size";
          variantPicker.appendChild(errorMessage);
          setTimeout(() => {
            document.querySelector(".error-message").remove();
          }, 3000);
          return false;
        }

        if (formData.get("option3") || selected_option && e.target.closest('.buy-buttons-engraving')) {
          let size = formData.get("option3");
          if (!size && selected_option) {
            size = selected_option;
          }
          url += "&" + "size=" + size + "&letter=" + transformLetterToShort(formData.get("option2") || '') + "&qty=" + qty;
        } else {
          url += "&size=" + transformLetterToShort(formData.get("option2") || '') + "&qty=" + qty;
        }
     
        window.location.href = url;
        return false;
    });
  }
  });
}

console.log('pathName', pathName)
fetch(`${pathName}.js`)
  .then(response => response.json())
  .then(product => {
    console.log('print DATA', product);
    let variantsHTMLMobile = '';
    let variantsHTMLDesktop = '';
    const productVariants = product.variants;

   
    let selectedVariant = productVariants.find(v => v.available === true); 
    if(selectedVariant == undefined) {
      selectedVariant = productVariants[0];
    }
    
    let sizeIndex = -1;
    if(product.options[0].name != 'Title') {
        product.options.forEach((option, index) => {
          // let values = [...new Set(productVariants.map(variant => variant.options[index]))];
           let values = option.values;
           const optionName = option.name;
           let hiddenClass = (optionName.toLowerCase().includes('bead') && values.length < 2) ? ' hidden' : (optionName.toLowerCase().includes('color')) ? ' hidden' : '';
          
           if(optionName.toLowerCase().includes('size')) {
               sizeIndex = index;
               hiddenClass = hiddenClass + ' size-dropdown';
           }
        variantsHTMLMobile += `
          <div class="dropdown-container option-container${hiddenClass}">
              <div class="dropdown-label"><span>${selectedVariant.options[index]}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M3.83997 7.09001L9.49997 12.75L15.16 7.09001L14.45 6.39001L9.49997 11.34L4.54997 6.39001L3.83997 7.09001Z" fill="black"/>
              </svg>
            </div> 
            <ul>
            ${values
              .map(value => {
                let variant = productVariants.find(v => v.options[index] === value);
                let isSoldOut = !variant || !variant.available;
                let selectedClass = '';
                if(isSoldOut) {
                  selectedClass = selectedClass+ ' sold-out';
                }  
                if(variant.id == selectedVariant.id) {
                   selectedClass = selectedClass+ ' selected';
                }
                return `
                   <li class="${selectedClass} " value="${value}" data-variant-id="${variant.id}">
                     ${value}
                  </li>
                `;
              })
              .join('')}
              </ul>
              <div class="error">Please select size!</div>
          </div>
        `;
      });
      
        product.options.forEach((option, index) => {
       // let values = [...new Set(productVariants.map(variant => variant.options[index]))];
        let values = option.values;
        const optionName = option.name;
        let hiddenClass = (optionName.toLowerCase().includes('bead') && values.length < 2) ? ' hidden' : (optionName.toLowerCase().includes('color')) ? ' hidden' : '';
          
          
       
        variantsHTMLDesktop += `
          <fieldset class="option-container${hiddenClass}">
            ${values
              .map(value => {
                let variant = productVariants.find(v => v.options[index] === value);
                let isSoldOut = !variant || !variant.available;
                return `
                 <input js-index="${index}" data-variant-id="${variant.id}" id="variant-${value.toLowerCase()}" ${variant.id === selectedVariant?.id && selectedVariant?.available == true ? 'checked' : ''}  type="radio" name="option-${index}" value="${value}" ${isSoldOut ? 'disabled' : ''}>
                  <label for="variant-${value.toLowerCase()}" class="option-label">
                    <span class="option-text ${isSoldOut ? 'sold-out' : ''}">${value}</span>
                  </label>
                `;
              })
              .join('')}
          </fieldset>
        `;
      });
    }
    

    let btnClass = selectedVariant.available == false ?'disabled' : '';
    const mainElement = document.querySelector('body');

    let productTitle = product.title;
    if(product.title.length > 38) {
      productTitle = productTitle.slice(0, 38).concat('...');
    }
    let productTitleMobile = product.title;
    if(product.title.length > 28) {
      productTitleMobile = productTitleMobile.slice(0, 28).concat('...');
    }

     let customizerClass = 'hidden'; 
     let isCustomizer = false; 

    
     let customizeURL = `${product.url}?view=customizer&qty=1`;
     product.options.forEach((option, index) => {
        const optionName = option.name.toLowerCase();
        customizeURL = `${customizeURL}&${optionName}=${selectedVariant.options[index]}`;
     });
    
     const productTags = product.tags;
     if(productTags.length > 0) {
      if(productTags.indexOf('collection_custom') != -1) {
        if(productTags.indexOf('exclude_from_customizer') == -1) {
           isCustomizer = true;
           btnClass = btnClass + ' hidden';
           customizerClass = ''; 
        }
      }
     }

    if(selectedVariant?.available == false) {
       customizerClass = 'hidden'; 
    }
   
    
    let HTML = `<div class="product-bottom-bar" js-product-bottom-bar>
      <div class="left-part">
         <div class="image">
           <img js-image src="${selectedVariant.featured_image != null?selectedVariant.featured_image.src:product.featured_image != null?product.featured_image:''}" />
         </div>
         <div class="product-title desktop">${productTitle}</div>
          <div class="product-title mobile">${productTitleMobile}</div>
        
      </div>
      <div class="right-part">
       <div class="product-variants desktop">${variantsHTMLDesktop}</div>
         <div class="product-variants mobile">${variantsHTMLMobile}</div>
         
        <form method="post" action="/cart/add">
          <input type="hidden" name="id" js-id value="${selectedVariant.id}">

         
          <a href="${customizeURL}" data-href="/products/custom-sea-salt?view=customizer" class="customizer-external-link btn-customizer button ${customizerClass}" js-customize-btn>Start Customizing</a>
           
          <button js-add-btn type="submit" ${selectedVariant?.available == false ? 'disabled' : ''} class="button ${btnClass}">
              <span class="btn-text-desktop">${selectedVariant.available == false ?'SOLD OUT' : 'ADD TO CART'}</span> 
              <span class="btn-text-mobile">${selectedVariant.available == false ?'SOLD OUT' : 'ADD'}</span> 
              <span>-</span> 
              <span js-price>
              ${Shopify.money_format.replace(/{{\s*amount(_with_comma_separator)?\s*}}/, (match) => 
              (selectedVariant.price / 100).toLocaleString()
              )}
              </span>
          </button>
          
        </form>
       
      </div>
     </div>`;
    mainElement?.insertAdjacentHTML("afterBegin", HTML);

    afterInitialization(product);
    customizerExternalLink();

    if(product.options[0].name != 'Title') {
          const urlParams = new URLSearchParams(window.location.search);
          const currentVariant = urlParams.get("variant");
          if(currentVariant) {
            changeFieldSetByVariant(Number(currentVariant), product);
          }
     }
    
  });

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    (rect.top-45) >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const getVariant = (product) => {
    const allFieldsets = document.querySelectorAll('[js-product-bottom-bar] fieldset');
    let selectedOptions = [];

    allFieldsets.forEach(fieldset => {
      const selectedInput = fieldset.querySelector('input:checked, select');
      if (selectedInput) {
        selectedOptions.push(selectedInput.value);
      }
    });
    
    // Assuming `variantData` is an array of product variants from Shopify's JSON
    const variant =product.variants.find(v => 
      JSON.stringify(v.options) === JSON.stringify(selectedOptions)
    );
    
    if (variant) {
      return variant;
    } else {
      return null;
    }
}

const getVariantMobile = (product) => {
    
    let selectedOptions = [];

    const dropDownContainer = document.querySelectorAll('[js-product-bottom-bar] .dropdown-container');
    dropDownContainer.forEach((container, index) => {
        const dropDown = container.querySelector('ul li.selected');
        if (dropDown) {
          selectedOptions.push(dropDown.getAttribute('value'));
        }
    });
    
    // Assuming `variantData` is an array of product variants from Shopify's JSON
    const variant =product.variants.find(v => 
      JSON.stringify(v.options) === JSON.stringify(selectedOptions)
    );
    
    if (variant) {
      return variant;
    } else {
      return null;
    }


   
  
}


const afterInitialization = (product) => {
   
    const variantInputs = document.querySelectorAll('[js-product-bottom-bar] fieldset input');
    variantInputs.forEach((input)=> {
      input.addEventListener("change", (event) => {
        const variant = getVariant(product);
        console.log('variant', variant);
        if(variant) {
         onVariantChange(variant.id, product);
         mainVariantChange(variant.id, product);
        }
      });
    })

   const addBtn = document.querySelector('[js-product-bottom-bar] [js-add-btn]');
   addBtn.addEventListener("click", (event) => {
     event.preventDefault();

     if(window.innerWidth <= 749) {
       if(document.querySelector('[js-product-bottom-bar] .dropdown-container.size-dropdown')) {
          const activeLength = document.querySelector("[js-product-bottom-bar] .dropdown-container ul li.selected");
          if(activeLength == null) {
            const errorElement = document.querySelector("[js-product-bottom-bar] .dropdown-container.size-dropdown .error");
            errorElement.classList.add('active');
            return;
          }
       }
     }
     
     addBtn.classList.add('disabled');
     addBtn.setAttribute('disabled', 'disabled');
     const variantID = document.querySelector('[js-product-bottom-bar] [js-id]').value;
   
     const form = addBtn.closest('form');
     if(form) {

           const formData = new FormData(form);
            
              fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
                  return response.json();
                })
                .then((result) => {
                  document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", {
                      bubbles: true,
                    })
                  );
                  setTimeout(()=> {
                    const drawer = document.querySelector("cart-drawer");
                    if (drawer) {
                      drawer.show();
                    }
                    addBtn.classList.remove('disabled');
                    addBtn.removeAttribute('disabled');
                  }, 1000);
                 
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
       
     }
   });
  

   window.addEventListener('scroll', function(event) {
    const scrollPosition = window.scrollY;
      if(window.innerWidth <= 749) {

        const mainAddToCart = document.querySelector('div[data-block-type="buy-buttons"] .buy-with-quantity');
       
        const isVislble = isElementInViewport(mainAddToCart);
        
           if(!isVislble) {
             document.querySelector('[js-product-bottom-bar]').classList.add('active');
           } 
           else {
               document.querySelector('[js-product-bottom-bar]').classList.remove('active');
           }
      }
     else {
        if(scrollPosition >= 300) {
             document.querySelector('[js-product-bottom-bar]').classList.add('active');
           } 
           else {
               document.querySelector('[js-product-bottom-bar]').classList.remove('active');
           }
      }
    });

  //=========== mobile
    const dropdowns = document.querySelectorAll("[js-product-bottom-bar] .dropdown-container");
    dropdowns.forEach((container)=> {
        const selectedOption = container.querySelector(".dropdown-label");
        const optionsList = container.querySelectorAll("ul li");
        selectedOption.addEventListener("click", function () {
            container.classList.toggle("active");
        });
        optionsList.forEach((item)=> {
          item.addEventListener("click", function (event) {
             selectedOption.querySelector('span').textContent =item.textContent;
             container.classList.remove("active");
             optionsList.forEach((i)=> {
                i.classList.remove('selected');
             });
             item.classList.add('selected');
             const variant = getVariantMobile(product);
             console.log('variant', variant);
            if(variant) {
           
               onVariantChange(variant.id, product);
               mainVariantChange(variant.id, product);
            }
            container.querySelector('.error')?.classList.remove('active');
             
          });
        });
        
    });
    // Close dropdown when clicking outside
    document.addEventListener("click", function (event) {
       dropdowns.forEach((container)=> {
         if (!container.contains(event.target)) {
           container.classList.remove("active");
         }
       });
    });

   
  
}

//====  for sticky bar options
const changeFieldSetByVariant = (variantID, product)=> {
  console.log('changeFieldSetByVariant');
  const allFieldsets = document.querySelectorAll('[js-product-bottom-bar] fieldset');
  const variant = product.variants.find(v => v.id == variantID);
  allFieldsets.forEach((fieldset, index) => {
    const optionValue = variant.options[index];
    const radioInput = fieldset.querySelector(`input[type="radio"][value="${optionValue}"]`);
    if (radioInput) {
      radioInput.checked = true;
      return;
    }
  });


  const dropDownContainer = document.querySelectorAll('[js-product-bottom-bar] .dropdown-container');
  dropDownContainer.forEach((container, index) => {
    const optionValue = variant.options[index];
    const dropDowns = container.querySelectorAll('ul li');
    
     let selectedOption = null;
      container.querySelectorAll('ul li').forEach((li)=> {
        if(li.getAttribute('value') == optionValue) {
          selectedOption = li;
        }
      });
     dropDowns.forEach((item)=> {
       item.classList.remove('selected');
     });
     selectedOption?.classList.add('selected');
     const dropDownSpan = container.querySelector('.dropdown-label span');
     dropDownSpan.textContent = optionValue;
  });
 
  
}

const onVariantChange = (variantID, product)=> {
 
        const variantDrop = product.variants.find(v => v.id === variantID); 
        const imageSrc = variantDrop.featured_image != null?variantDrop.featured_image.src:product.featured_image != null?product.featured_image:'';
       // const variantPrice = Shopify.money_format.replace('{{amount}}', variantDrop.price/100);
        const variantPrice = Shopify.money_format.replace(/{{\s*amount(_with_comma_separator)?\s*}}/, (match) => 
        (variantDrop.price / 100).toLocaleString()
      );

        const imageElement = document.querySelector('[js-image]');
        const idElement = document.querySelector('[js-id]');
        const priceElement = document.querySelector('[js-price]');
        imageElement.setAttribute('src', imageSrc);
        priceElement.innerHTML = variantPrice;
        idElement.value = variantDrop.id;

       if(document.querySelector(`[js-product-bottom-bar] [js-customize-btn]`)) {
          let customizeURL = `${product.url}?view=customizer&qty=1`;
          product.options.forEach((option, index) => {
           const optionName = option.name.toLowerCase();
           customizeURL = `${customizeURL}&${optionName}=${variantDrop.options[index]}`;
          });
         document.querySelector(`[js-product-bottom-bar] [js-customize-btn]`).setAttribute('href', customizeURL);
       }

     
      
}

const mainVariantChange = (variantID, product)=> {
    console.log('mainVariantChange');
     const variant = product.variants.find(v => v.id === variantID); 

     const allFieldsets = document.querySelectorAll(`safe-sticky.product-info variant-picker fieldset`);
     allFieldsets.forEach((fieldset, index) => {
      const optionValue = variant.options[index];
      const radioInput = fieldset.querySelector(`input[type="radio"][value="${optionValue}"]`);
      if (radioInput) {
        radioInput.checked = true;
         console.log('radioInput', radioInput);
        radioInput.dispatchEvent(new Event("change", { bubbles: true }));
       // return;
      }
    });

}